export default __webpack_public_path__ + "static/media/logout.a8ed0124.svg";